import { render, staticRenderFns } from "./MusicalAlert.vue?vue&type=template&id=73c87c24&scoped=true"
import script from "./MusicalAlert.vue?vue&type=script&lang=js"
export * from "./MusicalAlert.vue?vue&type=script&lang=js"
import style0 from "./MusicalAlert.vue?vue&type=style&index=0&id=73c87c24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c87c24",
  null
  
)

export default component.exports